<svelte:options />

<script lang="ts">
  import { isSidebarOpen } from './sidebar-service';
</script>

<span
  role="separator"
  class="mc-sidebar-separator {$isSidebarOpen ? 'is-open' : 'is-close'}"
/>

<style lang="scss">
  @import './sidebar-variables';

  .mc-sidebar-separator {
    border-bottom: 1px solid $color-grey;
    display: flex;

    &.is-close {
      @include transition(margin 300ms ease-in-out);
      margin: 24px 0;
    }

    &.is-open {
      @include transition(margin 300ms ease-in-out);
      margin: 24px 32px;
    }
  }
</style>
